import PropTypes from 'prop-types';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const PendingSearchContext = createContext({
	keyword: '',
	setKeyword: () => {},
	clearKeyword: () => {},
	initialApplyingPageIndex: null,
});

export const PendingSearchProvider = ({ children, initialKeyword = '', initialApplyingPageIndex = null }) => {
	const [keyword, setKeywordState] = useState(() => (typeof initialKeyword === 'string' ? initialKeyword : ''));
	const applyingPageIndex =
		Number.isInteger(initialApplyingPageIndex) && initialApplyingPageIndex >= 0 ? initialApplyingPageIndex : null;

	const setKeyword = useCallback((value) => {
		setKeywordState(typeof value === 'string' ? value : '');
	}, []);

	const clearKeyword = useCallback(() => {
		setKeywordState('');
	}, []);

	const value = useMemo(
		() => ({
			keyword,
			setKeyword,
			clearKeyword,
			initialApplyingPageIndex: applyingPageIndex,
		}),
		[keyword, setKeyword, clearKeyword, applyingPageIndex],
	);

	return <PendingSearchContext.Provider value={value}>{children}</PendingSearchContext.Provider>;
};

PendingSearchProvider.propTypes = {
	children: PropTypes.node,
	initialKeyword: PropTypes.string,
	initialApplyingPageIndex: PropTypes.number,
};

export const usePendingSearch = () => useContext(PendingSearchContext);

export default PendingSearchProvider;
